import { useState, useEffect } from "react";
import React from "react";
import { toast } from 'react-toastify';
import { useNavigate, useParams } from "react-router-dom";
import Pagination from '@mui/material/Pagination';
import { API_FACTURAS } from '../shared/services/facturas';
import Header from '../shared/components/Header'
import moment from 'moment';
import InfoModal from "../shared/components/InfoModal";
import { useDispatch, useSelector } from "react-redux";
import { fetchFacturas } from "../../../../redux/facturas";
import ExportForm from "../shared/components/ExportForm";
import ActionsMenu from "../shared/components/ActionsMenu";
import { getActions } from "./actions";
import ConfirmModal from '../shared/components/ConfirmModal';
import { setErrorMessage } from '../shared/helpers/functionalities';

export default function Facturas() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { page } = useParams();
  const currPage = parseInt(page);
  const user = JSON.parse(localStorage.getItem('user'));
  const [isExport, setIsExport] = useState(false);
  const [isCompare, setIsCompare] = useState(false);
  const [isReport, setIsReport] = useState(false);
  const [currentPage, setPage] = useState(currPage);
  const [openConfirmNoGenerated, setOpenConfirmNoGenerated] = useState(false);
  const tipoFacturas = useSelector(state => {
    const { tipo_facturas } = state;
    return tipo_facturas;
  });
  const facturas = useSelector(state => state.facturas);
  const searcher = useSelector(state => state.search)

  useEffect(() => {
    dispatch(fetchFacturas(currPage, getQuery()));
  }, [searcher]);

  const getQuery = () => {
    const isEmpty = Object.values(searcher).every(x => x === null || x === '');
    let query = !isEmpty ? 'search=' + (searcher?.search ? searcher?.search : '')
    : null;

    return query;
  }
  
  const handleSearch = (search, searchData) => {
    setPage(1);
    navigate(`/facturas/${1}`);
    dispatch({type: "search/set", payload: searchData});     
  }

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    navigate(`/facturas/${newPage}`);
    dispatch(fetchFacturas(newPage, getQuery()));
  }

  const getPaginationCount = () => {
    var totalPages = facturas?.total_items < 15 ? 1 : Math.ceil(facturas?.total_items / 15);
    return totalPages ? parseInt(totalPages) : 0;
  }

  const handleAction = (action, factura) => {
    if(action === 'download') {
      generateThePdf(factura)
    } else  if(action === 'regenerate') {
      regenerate(factura)
    }
  }

  const regenerate = async(factura) => {
    dispatch({type: 'loading/set', payload: true});
    const response = await API_FACTURAS.regenerateFactura({factura_id: factura.id});

    if(response && response.success) {
      dispatch({type: 'loading/set', payload: false});
      toast.success(response.message);
    }
  }

  const generateThePdf = async (factura) => {
      dispatch({type: 'loading/set', payload: true});
      const pdfResult = await API_FACTURAS.generateFacturaPDF(factura.id);

      if(pdfResult) {
        window.open(pdfResult.data, "_blank");
      } else {
        toast.error('Ups! Algo ha ido mal...')
      }
      dispatch({type: 'loading/set', payload: false});
  }

  const getTipoFacturaName = (tipoClienteId) => tipoFacturas.find(tp => tp.id === tipoClienteId)?.nombre;

  const handleExport = () => { setIsExport(true); }
  const handleReport = () => setIsReport(true);
  const handleCloseExport = () => setIsExport(false);
  const handleCloseReport = () => setIsReport(false);
  const handleCompare = () => setIsCompare(true);
  const handleCloseCompare = () => setIsCompare(false);

  const handleCompareFacturasAndVentas = async(data)  => {
    const exportResult = await API_FACTURAS.compareFacturasAndVentas(data);

    if(exportResult) {
      const start = moment(data.startDate).format('DD-MM-YYYY');
      const end = moment(data.endDate).format('DD-MM-YYYY');

      toast.success('Facturas descargadas correctamente!')
      setIsExport(false);
    
      const url = window.URL.createObjectURL(new Blob([exportResult]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'facturas-' + start + '-' + end + '.xlsx');
      document.body.appendChild(link);
      link.click();
    } else {
      toast.error('Ups! Algo ha ido mal...')
    }
  }

  const handleExportFacturas = async (data) => {
    dispatch({type: 'loading/set', payload: true});
    const exportResult = await API_FACTURAS.exportExcel(data);

    if(exportResult) {
      dispatch({type: 'loading/set', payload: false});
      const start = moment(data.startDate).format('DD-MM-YYYY');
      const end = moment(data.endDate).format('DD-MM-YYYY');

      toast.success('Facturas descargadas correctamente!')
      setIsExport(false);
    
      const url = window.URL.createObjectURL(new Blob([exportResult]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'facturas-' + start + '-' + end + '.xlsx');
      document.body.appendChild(link);
      link.click();
    } else {
      toast.error('Ups! Algo ha ido mal...')
    }
  };

  const handleExcelReport = async (data) => {
    dispatch({type: 'loading/set', payload: true});
    const reportResult = await API_FACTURAS.exportReport(data);

    if(reportResult) {
      dispatch({type: 'loading/set', payload: false});
      const start = moment(data.startDate).format('DD-MM-YYYY');
      const end = moment(data.endDate).format('DD-MM-YYYY');

      toast.success('Informe descargado correctamente!')
      setIsExport(false);
    
      const url = window.URL.createObjectURL(new Blob([reportResult]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'informe_ventas-' + start + '-' + end + '.xlsx');
      document.body.appendChild(link);
      link.click();
    } else {
      toast.error('Ups! Algo ha ido mal...')
    }
  }

  const handleViewAFacturasDesguaces = () => {
    localStorage.removeItem('searcher');
    navigate('/facturas-desguaces/1');
  }

  const handleViewNotasCargo = () => {
    localStorage.removeItem('searcher');
    navigate('/notas-cargo/1');
  }

  const getSubtotal = (factura) => {
    return parseFloat(factura.subtotal).toFixed(2);
  }

  const getTotalIVA = (factura, conDescuento) => {
    let totalIVA;

    if(conDescuento) {
      totalIVA = factura.total_iva;
    } else {
      totalIVA = factura.total_iva + factura.total_descuento_iva
    }
    
    return parseFloat(totalIVA).toFixed(2);
  }

  const handleNoGenerated = async(confirm) => {
    if (confirm) {
      try {
        dispatch({type: 'loading/set', payload: true});
        const res = await API_FACTURAS.noGenerated();
        if(res?.success) {
          toast.success(res.message);
        } else {
          toast.error('No se han podido generar correctamente...')
        }
      } catch (error) {
        toast.error(setErrorMessage(error))
      } finally {
        dispatch({type: 'loading/set', payload: false});
      }
    }
    setOpenConfirmNoGenerated(false)
  }

  return (
    <div className="content pt-3">
      <Header  
        viewSearch={true}
        onSearch={handleSearch} 
        onExport={handleExport} 
        onReport={handleReport}
        onCompare={handleCompare}
        onNoGenerated={() => setOpenConfirmNoGenerated(true)}
      />

      <div className="w-100 d-flex flex-column align-items-end content-table">
        <div className="d-flex align-items-center mb-3">
          { (user.rol_id === 1 || user.rol_id === 4) &&
            <button className="btn btn-info me-3" onClick={handleViewAFacturasDesguaces}>Facturas Desguaces</button>
          }
          <button className="btn btn-default me-3" onClick={handleViewNotasCargo}>Notas de cargo</button>
        </div>

        <div className="table-responsive">
          <table className="table">
            <thead>
              <tr>
                <th>Nº</th>
                <th className="text-center">tipo</th>
                <th className="text-center">fecha</th>
                <th className="text-center">venta</th>
                <th className="text-center">devolucion</th>
                <th className="text-center">total</th>
                <th className="text-center">total envío</th>
                <th className="text-center">total casco</th>
                <th className="text-center">subtotal</th>
                <th className="text-center">I.V.A</th>
                <th className="text-center">total I.V.A</th>
                <th className="text-center">descuento</th>
                <th className="text-center">total I.V.A</th>
                <th className="text-center"></th>
              </tr>
            </thead>

            <tbody>
              { facturas.facturas?.map((factura) => {
                return (
                  <tr key={factura.id}>
                    <td>{factura.numero}</td>
                    <td className="text-center text-uppercase">{tipoFacturas?.length > 0 ? getTipoFacturaName(factura.tipo_factura_id) : ''}</td>
                    <td className="text-center">{moment(factura.fecha).format("DD-MM-YYYY")}</td>
                    <td className="text-center">
                      { (factura.tipo_factura_id !== 4) ?
                        factura.venta_id
                        : factura.ventas
                      }
                    </td>
                    <td className="text-center">
                      { (factura.tipo_factura_id !== 4) ? 
                        (factura.devolucion_id !== null ? factura.devolucion_id : '')
                        : factura.devoluciones
                      }
                    </td>
                    <td className="text-center">{parseFloat(factura.total).toFixed(2)}€</td>
                    <td className="text-center">{parseFloat(factura.total_envio).toFixed(2)}€</td>
                    <td className="text-center">{parseFloat(factura.total_casco).toFixed(2)}€</td>
                    <td className="text-center">{getSubtotal(factura)}€</td>
                    <td className="text-center">{factura.iva}%</td>
                    <td className="text-center">{getTotalIVA(factura, false)}€</td>
                    <td className="text-center">
                      { (factura?.vale_descuento || factura?.codigo_descuento_masivo) ?
                        <div className="d-flex flex-column">
                          { (factura.tipo_factura_id === 2 || factura.tipo_factura_id === 3) ? 
                              +parseFloat(factura.total_descuento_iva > 0 ? factura.total_descuento_iva : factura.total_descuento).toFixed(2) + '€'
                              : 
                              -parseFloat(factura.total_descuento_iva > 0 ? factura.total_descuento_iva : factura.total_descuento).toFixed(2) + '€'
                          }
                          <span className="fw-bold text-green">{factura?.vale_descuento?.codigo || factura?.codigo_descuento_masivo}</span>
                        </div>
                        : '-'
                      }
                    </td>
                    <td className="text-center">{getTotalIVA(factura, true)}€</td>
                    <td className="text-center">
                      <ActionsMenu 
                          options={getActions()}
                          onAction={(action) => handleAction(action, factura)}
                      />
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>

        <Pagination 
          className="mt-3" 
          count={getPaginationCount()} 
          page={currentPage} 
          onChange={handleChangePage} 
        />
      </div>

      { isExport && 
        <InfoModal
          state={isExport}
          title="Exportar facturas a Excel"
          content={
            <ExportForm 
              dateFilter={true}
              responsableFilter={false}
              tipoClienteFilter={false}
              tipoFacturasFilter={true}
              companyFilter={true}
              onSubmitExport={handleExportFacturas}
            />
          }
          onClose={handleCloseExport}
        ></InfoModal>
      }

      { isCompare && 
        <InfoModal
          state={isCompare}
          title="Comparar facturas y ventas a Excel"
          content={
            <ExportForm 
              dateFilter={true}
              responsableFilter={false}
              tipoClienteFilter={false}
              tipoFacturasFilter={false}
              onSubmitExport={handleCompareFacturasAndVentas}
            />
          }
          onClose={handleCloseCompare}
        ></InfoModal>
      }

      { isReport && 
        <InfoModal
          state={isReport}
          title="Generar informe de ventas a Excel"
          content={
            <ExportForm 
              dateFilter={true}
              responsableFilter={true}
              tipoClienteFilter={false}
              tipoFacturasFilter={false}
              onSubmitExport={handleExcelReport}
            />
          }
          onClose={handleCloseReport}
        ></InfoModal>
      }

      { openConfirmNoGenerated && 
        <ConfirmModal
            onConfirmAction={handleNoGenerated}
            onClose={() => setOpenConfirmNoGenerated(false)}
            title={'Facturas pendientes de generar'} 
            description={'¿Quieres comprobar si hay facturas pendientes y generarlas?'}
            state={openConfirmNoGenerated}>
        </ConfirmModal>
      }
    </div>
  )
}